import { useAutoPilotSettings } from 'modules/Settings/hooks/useAutoPilotSettings';
import { useFeatureFlag } from 'modules/common/hooks';

export const useAutoPilotEnabled = (): boolean => {
  const { data } = useAutoPilotSettings();
  const isTiAutoAcceptUserSettingsEnabled = useFeatureFlag(
    'isTiAutoAcceptUserSettingsEnabled'
  );
  return (
    (data?.getAutoAcceptSettings?.enabled &&
      isTiAutoAcceptUserSettingsEnabled) ||
    false
  );
};
